import { FC } from 'react';

import {
  PrimaryBannerSection,
  PrimaryBannerSectionProps,
} from '../../components/homepage/homepage-sections/PrimaryBannerSection';
import {
  SupplementalBannerSection,
  SupplementalBannerSectionProps,
} from '../../components/homepage/homepage-sections/SecondaryBannerSection';
import {
  RecommendationsSection,
  RecommendationsSectionProps,
} from '../../components/homepage/homepage-sections/RecommendationsSection';
import {
  ProductListSection,
  ProductListSectionProps,
} from '../../components/homepage/homepage-sections/ProductListSection';
import {
  SeoSection,
  SeoSectionProps,
} from '../../components/homepage/homepage-sections/SeoSection';

interface SectionCollectionProp<T> { [key: string]: T; }

// To be used for mapping homepage sections.
export const SECTION_COLLECTION: SectionCollectionProp<
FC<PrimaryBannerSectionProps>
| FC<SupplementalBannerSectionProps>
| FC<RecommendationsSectionProps>
| FC<ProductListSectionProps>
| FC<SeoSectionProps>
> = {
  primary_banner_section: PrimaryBannerSection,
  supplementary_banner_section: SupplementalBannerSection,
  recommendations_section: RecommendationsSection,
  product_list_section: ProductListSection,
  seo_section: SeoSection,
};
